<article class="timeline-item">
  <span class="timeline-marker" role="img" [attr.aria-label]="ariaLabel"></span>
  <div class="timeline-content"><ng-content></ng-content></div>
</article>